export const resumeLines = content => content.split('\n').map(line => line.trim().replace(/^\+\s*/, '').replace(/\s{2,}/g, ' ').replace(/([0-9]{4})(?=[A-Za-z])/g, '$1 ')).filter(Boolean);

export const projectEntries = content => resumeLines(content).filter(line => !/^Actively participated in healthcare Projects:/i.test(line));

// Keep every CV line, grouping dated appointments and degrees into readable entries.
export function datedEntries(content) {
  const entries = [];
  for (const line of resumeLines(content)) {
    if (!entries.length || /^(?:Jan\b|Sep\b|[0-9۰-۹]{4}|ژانویه|سپتامبر)/i.test(line)) entries.push({ heading: line, lines: [] });
    else entries[entries.length - 1].lines.push(line);
  }
  return entries;
}
